import './Icon.css'
import FowardArrowIcon from './icons/forwardArrowIcon'
import { useTranslator } from '../translator/hook'

interface ForwardButtonProps {
  onClick: () => void
}

export const ForwardButton = ({ onClick }: ForwardButtonProps) => {
  const { t } = useTranslator()

  return (
    <div className="menu-container icon-container">
      <button className="icon-button" onClick={onClick}>
        <FowardArrowIcon className="icon" />
        <div className="icon-caption"> {t('REDO')}</div>
      </button>
    </div>
  )
}
